export const WORKSPACE_ORG_TYPES = [
    'Consultancy',
    'Private Equity',
    'Corporate',
    'Startup',
    'Scaleup',
    'Government',
    'Non-Profit',
];

export const ORG_DESCRIPTION_PLACEHOLDER =
    'Describe what your organisation does, who it serves and how it creates value.';

export const OFFERINGS_PLACEHOLDER = `List your primary services, products or capabilities.
Examples:
Technology Due Diligence
Post-Merger Integration
Technology Strategy
Cybersecurity Assessments`;

export const IDEAL_CUSTOMER_PROFILE_PLACEHOLDER = `Describe your target customers, clients or investment focus.
Mid-market private equity firms acquiring technology-enabled businesses.`;

export const normalizeOrgProfile = profile => ({
    org_type: (profile?.org_type || '').trim(),
    org_description: (profile?.org_description || '').trim(),
    offerings: (profile?.offerings || '').trim(),
    ideal_customer_profile: (profile?.ideal_customer_profile || '').trim(),
});

export const ORG_PROFILE_KEYS = ['org_type', 'org_description', 'offerings', 'ideal_customer_profile'];
